import styled from 'styled-components';

import { Button } from '@xsolla/ui-core';

export const Wrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.stroke};
  max-width: 468px;
  min-width: 140px;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 3px 12px 0 rgb(0 36 77 / 20%);
`;

export const Container = styled.div`
  padding: 4px 0;
  width: 100%;
  max-height: 280px;
  overflow-x: auto;
  user-select: none;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
  padding: 4px 12px;
  box-sizing: border-box;
`;

export const CountLabel = styled.p`
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.text};
`;

export const UnselectButton = styled(Button)`
  height: 16px;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
`;

export const Item = styled.div`
  padding: 8px;
`;
